// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"1294a076","374":"bc15b372","393":"7f8b1d7d","772":"c02c7a2f","852":"c89fb9ff","891":"cbf5d78a","966":"57b6d122"}[chunkId] + ".chunk.css";
};